import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const VdaScore: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const vdaScoreFormula = createMathML(`
    <mrow>
      <msub>
        <mi>S</mi>
        <mi>VDA</mi>
      </msub>
      <mo>=</mo>
      <msub>
        <mi>W</mi>
        <mi>C</mi>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mi>B</mi>
      </msub>
      <mo>+</mo>
      <msub>
        <mi>W</mi>
        <mi>L</mi>
      </msub>
    </mrow>
  `);

  return (
    <MathMLRenderer 
      mathML={vdaScoreFormula} 
      className={className} 
      style={style} 
    />
  );
};